import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

class TrendingBarModal extends React.Component {
  state = {
    id: null,
    label: "",
    url: "",
    sortOrder: 0,
    isActive: 1,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.modalData) {
      const rawUrl = nextProps.modalData.url || "";
      const fqdn = nextProps.fqdn || this.props.fqdn || "";
      // Prepend full domain to path for display
      const displayUrl = rawUrl && fqdn && !rawUrl.startsWith("http")
        ? `https://${fqdn}${rawUrl.startsWith("/") ? "" : "/"}${rawUrl}`
        : rawUrl;
      this.setState({
        id: nextProps.modalData.id || null,
        label: nextProps.modalData.label || "",
        url: displayUrl,
        sortOrder: nextProps.modalData.sortOrder !== undefined ? nextProps.modalData.sortOrder : 0,
        isActive: nextProps.modalData.isActive !== undefined ? nextProps.modalData.isActive : 1,
      });
    }
  }

  handleChange = (event, field) => {
    this.setState({ [field]: event.target.value });
  };

  handleActiveToggle = () => {
    this.setState((prev) => ({ isActive: prev.isActive ? 0 : 1 }));
  };

  stripToPath = (url) => {
    if (!url) return url;
    try {
      // If it's a full URL, extract just the pathname
      const parsed = new URL(url);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      // Already a path (e.g. /profile/super-bowl-lx)
      return url.startsWith("/") ? url : "/" + url;
    }
  };

  validateDomain = (url) => {
    const fqdn = this.props.fqdn || "";
    if (!fqdn || !url) return true;
    // If it's a full URL, check domain matches
    if (url.startsWith("http")) {
      try {
        const parsed = new URL(url);
        if (parsed.hostname !== fqdn) return false;
      } catch (e) {
        return false;
      }
    }
    return true;
  };

  handleSubmit = () => {
    if (!this.state.label || !this.state.url) {
      alert("Label and URL are required");
      return;
    }
    const fqdn = this.props.fqdn || "";
    if (!this.validateDomain(this.state.url)) {
      alert(`URL must belong to ${fqdn}. Please enter a valid ${fqdn} link.`);
      return;
    }
    this.props.submitTrendingBarItem({
      id: this.state.id,
      label: this.state.label,
      url: this.stripToPath(this.state.url),
      sortOrder: parseInt(this.state.sortOrder, 10) || 0,
      isActive: this.state.isActive,
    });
  };

  render() {
    const { classes, showModal, toggleTrendingBarModal, fqdn } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} md={12}>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal,
            }}
            open={showModal}
            aria-labelledby="trending-bar-modal-title"
            aria-describedby="trending-bar-modal-description"
          >
            <DialogTitle
              id="trending-bar-modal-title"
              disableTypography
              className={classes.modalHeader}
            >
              <Button
                justIcon
                className={classes.modalCloseButton}
                key="close"
                aria-label="Close"
                color="transparent"
                onClick={() => toggleTrendingBarModal(false)}
              >
                <Close className={classes.modalClose} />
              </Button>
              <h4 className={classes.modalTitle}>
                {this.state.id ? "Edit Trending Bar Item" : "Add Trending Bar Item"}
              </h4>
            </DialogTitle>
            <DialogContent
              id="trending-bar-modal-description"
              className={classes.modalBody}
            >
              <CustomInput
                id="tb-label"
                labelText="Label (e.g. Super Bowl LX 2026)"
                inputProps={{
                  onChange: (event) => this.handleChange(event, "label"),
                }}
                formControlProps={{
                  fullWidth: true,
                }}
                value={this.state.label}
              />
              <CustomInput
                id="tb-url"
                labelText={`URL (e.g. https://${fqdn || 'news.meaww.com'}/profile/super-bowl-lx)`}
                inputProps={{
                  onChange: (event) => this.handleChange(event, "url"),
                }}
                formControlProps={{
                  fullWidth: true,
                }}
                value={this.state.url}
              />
              <CustomInput
                id="tb-sort-order"
                labelText="Sort Order (lower = shown first)"
                inputProps={{
                  onChange: (event) => this.handleChange(event, "sortOrder"),
                  type: "number",
                }}
                formControlProps={{
                  fullWidth: true,
                }}
                value={this.state.sortOrder.toString()}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isActive === 1}
                    onChange={this.handleActiveToggle}
                    color="primary"
                  />
                }
                label={this.state.isActive ? "Active" : "Inactive"}
                style={{ marginTop: "10px" }}
              />
            </DialogContent>
            <DialogActions
              className={classes.modalFooter + " " + classes.modalFooterCenter}
            >
              <Button onClick={() => toggleTrendingBarModal(false)}>
                Close
              </Button>
              <Button
                onClick={this.handleSubmit}
                style={{ backgroundColor: "#fb4d24" }}
              >
                {this.state.id ? "Update" : "Create"}
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(modalStyle)(TrendingBarModal);
